import {LastCallError} from './LastCallError.js'

export class LastCallAlreadyExistsError extends LastCallError {
  constructor({errorType, detail}) {
    super({errorType, detail})
  }
}
